<b3-modal
  #feedbackModal
  [open]="open"
  overlay
  size="md"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    [heading]="modalHeading"
    aria-level="2"
    [icon]="modalIcon"
    [icon-tone]="modalIconTone"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <p *ngIf="modalDescription" class="project-register-feedback-modal__text">
      {{ modalDescription }}
    </p>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="project-register-feedback-modal__footer">
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        (b3-click)="onPrimaryAction()">
        {{ primaryActionLabel }}
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
